import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { observer } from "mobx-react-lite";
import { useCallback, useMemo } from "react";
import { DEFAULT_LANGUAGE, getSupportedLanguages } from "@devowl-wp/api-real-cookie-banner";
import { moveArrayElementsToBeginning } from "@devowl-wp/react-frontend";
import { TranslationInputFormFieldEntry } from "./language-input-form-field-entry.js";
import { useStores } from "../../../../../../../store/root.js";
const TranslationInputFormFields = observer(({ flexPathConfig, customPlaceholder, formProps, inputProps })=>{
    const { rcbUserSettingsStore: { settings: { translationSettings } } } = useStores();
    const languages = useMemo(()=>{
        return moveArrayElementsToBeginning(getSupportedLanguages(false), translationSettings.sourceLanguage, translationSettings.targetLanguage).filter((lang)=>lang !== DEFAULT_LANGUAGE);
    }, [
        translationSettings?.sourceLanguage,
        translationSettings?.targetLanguage
    ]);
    const renderLanguageItem = useCallback((lang, idx)=>/*#__PURE__*/ _jsx(TranslationInputFormFieldEntry, {
            lang: lang,
            flexPathConfig: flexPathConfig,
            customPlaceholder: customPlaceholder,
            formProps: formProps,
            inputProps: inputProps
        }, `TranslationInputFormFieldEntry-${idx}-${lang}`), [
        flexPathConfig,
        customPlaceholder,
        formProps,
        inputProps
    ]);
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: languages.map(renderLanguageItem)
    });
});
export { TranslationInputFormFields };
